<template>
  <app-panel :title-to="props.titleTo">
    <template #title>
      SMART CONTRACT CALLS
    </template>
    <template #end>
      <chart-controls
        v-model="selectedScope"
        class="u-hidden-mobile"/>
    </template>

    <line-chart
      :data="contractsStatistics"
      :interval-by="selectedScope.intervalBy"/>

    <chart-controls
      v-model="selectedScope"
      class="contracts-chart-panel__controls u-hidden-desktop"/>
  </app-panel>
</template>

<script setup>
const { contractsStatistics } = storeToRefs(useChartsStore())
const { fetchContractsStatistics } = useChartsStore()

const props = defineProps({
  titleTo: {
    type: String,
    default: null,
  },
  scope: {
    type: Object,
    default: CHART_SCOPE_PRESETS_OPTIONS[0],
  },
})

const selectedScope = ref(props.scope)

useAsyncData(async () => {
  await loadContractsStatistics()
  return true
})

if (import.meta.client) {
  watch(selectedScope, async () => {
    await loadContractsStatistics()
  })
}

async function loadContractsStatistics() {
  await fetchContractsStatistics(
    selectedScope.value.intervalBy,
    selectedScope.value.limit,
    selectedScope.value.scope)
}
</script>

<style scoped>
.contracts-chart-panel__controls {
  margin-top: var(--space-4);
}
</style>
